import { TelemetryProvider } from "@blocksuite/affine-shared/services";
import type { BlockStdScope } from "@blocksuite/std";

export type MermaidTelemetryAction = "edit-mode" | "export" | "render-error";

export function trackMermaidAction(
  std: BlockStdScope,
  action: MermaidTelemetryAction,
  value: string,
) {
  std.getOptional(TelemetryProvider)?.track("CanvasElementUpdated", {
    page: "whiteboard editor",
    segment: "toolbar",
    module: "toolbar",
    category: "mermaid",
    control: action,
    type: value,
  });
}
